import {REQUEST_TYPE} from '../../../constants';
import {doRequest} from '../../../helpers/network';
import {Finance} from '../../../helpers/Urls';
import {updateNpc} from '../tripAdvance';

const INITIAL_STATE = {
  npcChangeRequestSubmitting: false,
  npcChangeRequestError: null,
};

export const NPC_CHANGE_REQUEST_LOADING = 'NPC_CHANGE_REQUEST_LOADING';
export const NPC_CHANGE_REQUEST_COMPLETED = 'NPC_CHANGE_REQUEST_COMPLETED';
export const NPC_CHANGE_REQUEST_ERROR = 'NPC_CHANGE_REQUEST_ERROR';

// Raise an NPC amount-change request (POST /v2/finance/npc-change-request).
// Backend 400s (POD not received, pending CR exists, invalid amount, NPC not
// found) come back as {status:false, message} — surfaced via the caller.
export const requestNpcChange = (payload) => async (dispatch) => {
  dispatch({type: NPC_CHANGE_REQUEST_LOADING});

  try {
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.npcChangeRequestURL(),
      data: payload,
    });

    // The API uses a `status` boolean: business failures come back as HTTP 200
    // with {status:false, message}. Success is {status:true, ...} — and may
    // also return the updated NPC object (raw, or under `data`). Some responses
    // return the raw NPC directly (no `status` wrapper, identified by `id`).
    const isSuccess = !!response && (response.status === true || !!response.id);

    if (isSuccess) {
      dispatch({type: NPC_CHANGE_REQUEST_COMPLETED});
      // If the updated NPC block came back, push it into the trip-advance store
      // so the challan re-renders with the new status / amount / history. It may
      // be raw ({id,...}), under `data` ({data:{id,...}}), or nested a level
      // deeper ({data:{npc:{id,...}}}).
      const {data} = response;
      const npc = response.id
        ? response
        : data && data.npc && data.npc.id
        ? data.npc
        : data && data.id
        ? data
        : null;
      if (npc) {
        dispatch(updateNpc(npc));
      }
      return {success: true, data: npc, message: response.message};
    }

    const message =
      (response && response.message) || 'Failed to submit change request';
    dispatch({type: NPC_CHANGE_REQUEST_ERROR, error: message});
    return {success: false, message};
  } catch (err) {
    dispatch({type: NPC_CHANGE_REQUEST_ERROR, error: err});
    return {
      success: false,
      message:
        err?.response?.data?.message || err?.message || 'Something went wrong',
    };
  }
};

// Reducer
export default (state = INITIAL_STATE, action) => {
  const {type} = action || {};

  switch (type) {
    case NPC_CHANGE_REQUEST_LOADING:
      return {
        ...state,
        npcChangeRequestSubmitting: true,
        npcChangeRequestError: null,
      };

    case NPC_CHANGE_REQUEST_COMPLETED:
      return {...state, npcChangeRequestSubmitting: false};

    case NPC_CHANGE_REQUEST_ERROR:
      return {
        ...state,
        npcChangeRequestSubmitting: false,
        npcChangeRequestError: action.error,
      };

    default:
      return state;
  }
};
